import React from 'react';
import { CircularProgress } from '@mui/material';
import { ImageOutlined } from '@mui/icons-material';
import style from '../style';

const { HeaderThumbnail, thumbnail } = style;

export default function CourseThumbnail({ image, loading = false }) {
  // Si la imagen no ha sido cargada, se muestra un "Spinner".
  if (loading === true) {
    return <CircularProgress color="success" />;
  }

  // Si no hay imagen, se muestra un "Placeholder".
  if (!image) {
    return (
      <HeaderThumbnail>
        <ImageOutlined style={{ fontSize: '3rem', color: '#9e9e9e' }} />
      </HeaderThumbnail>
    );
  }

  // Si hay imagen de curso, se muestra.
  return (
    <HeaderThumbnail>
      <img src={image} alt="course thumbnail" style={thumbnail} />
    </HeaderThumbnail>
  );
}
